import React from 'react';
import { Calendar, MapPin, Clock, ArrowRight, Users, Video } from 'lucide-react';
import { Link } from 'react-router-dom';
import PageHero, { Section, CTABlock } from '../components/PageHero';
import { Button } from '../components/ui/button';

const events = [
  { type: 'OFFLINE SEMINAR', title: 'MBBS in Russia Guidance Seminar', city: 'Delhi', date: 'Sat, 15 Feb 2026', time: '11:00 AM Onwards', venue: 'The Lalit Hotel, Barakhamba Rd' },
  { type: 'OFFLINE SEMINAR', title: 'Free MBBS Counselling Meet', city: 'Mumbai', date: 'Sun, 23 Feb 2026', time: '10:00 AM Onwards', venue: 'ITC Grand Central, Parel' },
  { type: 'OFFLINE SEMINAR', title: 'Direct Admission Awareness Session', city: 'Ahmedabad', date: 'Sat, 1 Mar 2026', time: '11:00 AM Onwards', venue: 'Hyatt Regency, Ashram Road' },
  { type: 'OFFLINE SEMINAR', title: 'Parent-Student Guidance Program', city: 'Patna', date: 'Sun, 8 Mar 2026', time: '11:00 AM Onwards', venue: 'Hotel Panache, Fraser Road' },
  { type: 'WEBINAR', title: 'Live Q&A with Kazan Federal University Rep', city: 'Online', date: 'Sat, 15 Mar 2026', time: '5:00 PM IST', venue: 'Zoom Webinar (Free Registration)' },
  { type: 'OFFLINE SEMINAR', title: 'MBBS Guidance Seminar', city: 'Chennai', date: 'Sun, 22 Mar 2026', time: '11:00 AM Onwards', venue: 'Taj Coromandel, Nungambakkam' },
  { type: 'WEBINAR', title: 'FMGE Prep + Russia MBBS Roadmap', city: 'Online', date: 'Sat, 29 Mar 2026', time: '6:00 PM IST', venue: 'YouTube Live' },
  { type: 'OFFLINE SEMINAR', title: 'Direct University Meet', city: 'Bangalore', date: 'Sun, 5 Apr 2026', time: '10:00 AM Onwards', venue: 'The Leela Palace' },
];

export default function UpcomingEvents() {
  return (
    <>
      <PageHero eyebrow="Upcoming" title="Events &" highlight="Seminars"
        subtitle="Attend a free MBBS-in-Russia seminar in your city, or join our online webinars from anywhere. Meet counsellors and university representatives directly."
        breadcrumbs={[{ label: 'Upcoming Events' }]} />

      <Section>
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-5">
          {events.map((e, i) => (
            <div key={i} className="bg-white rounded-2xl border border-border p-6 card-lift">
              <div className="flex items-start justify-between">
                <span className="inline-flex items-center gap-1.5 px-2.5 py-1 rounded-full bg-brand/10 text-brand text-[10px] font-bold tracking-widest">
                  {e.type === 'WEBINAR' ? <Video className="w-3 h-3" /> : <Users className="w-3 h-3" />} {e.type}
                </span>
                <span className="text-[10px] font-bold uppercase tracking-widest text-muted-foreground">Free Entry</span>
              </div>
              <h3 className="font-serif text-lg font-bold text-primary mt-4 leading-snug">{e.title}</h3>
              <div className="mt-4 space-y-2 text-xs text-muted-foreground">
                <div className="flex items-center gap-1.5"><Calendar className="w-3.5 h-3.5 text-brand" /> {e.date}</div>
                <div className="flex items-center gap-1.5"><Clock className="w-3.5 h-3.5 text-brand" /> {e.time}</div>
                <div className="flex items-center gap-1.5"><MapPin className="w-3.5 h-3.5 text-brand" /> {e.city} · {e.venue}</div>
              </div>
              <div className="mt-5 pt-4 border-t border-border flex items-center justify-between">
                <span className="text-xs text-muted-foreground">Limited seats</span>
                <Link to="/seminar" className="text-xs font-bold text-brand hover:text-brand-dark flex items-center gap-1 group">
                  Register <ArrowRight className="w-3.5 h-3.5 transition-transform group-hover:translate-x-1" />
                </Link>
              </div>
            </div>
          ))}
        </div>
      </Section>

      <CTABlock title="Can't find a seminar in your city?" subtitle="Book a free 1-on-1 video counselling session with our verified advisors." cta="Book Video Counselling" href="/video-counselling" />
    </>
  );
}
